const e = {
  extends: "PowerBall",
  logo: !0
};
export {
  e as default
};
